"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

function range(tiny, small, normal, large, huge, propName, prefix) {
  var _a;

  if (prefix === void 0) {
    prefix = '&';
  }

  var styles = function styles(size) {
    var _a;

    return _a = {}, _a[propName] = size, _a;
  };

  return _a = {}, _a[prefix + "$tiny"] = styles(tiny), _a[prefix + "$small"] = styles(small), _a["" + prefix] = styles(normal), _a[prefix + "$large"] = styles(large), _a[prefix + "$huge"] = styles(huge), _a;
}

exports.styles = __assign({
  tiny: {},
  small: {},
  large: {},
  huge: {},
  inline: {},
  space: __assign(__assign({}, range(2, 4, 8, 16, 20, 'width')), {
    display: 'inline-block'
  }),
  vertical: __assign(__assign({}, range(8, 12, 20, 30, 40, 'height')), {
    '&$space': {
      display: 'block',
      width: '100%'
    }
  })
}, mobileStylesHelper_1.default(__assign(__assign(__assign({}, range(4, 8, 12, 16, 20, 'height')), {
  '&$space:not($inline)': {
    display: 'block',
    width: '100%'
  }
}), range(4, 8, 12, 20, 24, 'height', '&$vertical'))));